import { MediaPreview } from '@client/new/pages/workout/components/MediaPreview';
import { Button } from '@design-system/components/button/button';
import { Textarea } from '@design-system/components/textarea/textarea';
import { SubExerciseVM } from '../../../view-model/subexercise.viewmodel';
import { TitleInputWithHints } from '@client/new/pages/workout/components/titleInputWithHints/TitleInputWithHints';
import { LibraryHint } from './LibraryHint';

type ExerciseDetailsProps = {
  exercise: SubExerciseVM;
};

export const ExerciseDetails = ({ exercise: ex }: ExerciseDetailsProps) => {
  return (
    <>
      <TitleInputWithHints
        required
        value={ex.name}
        onChange={ex.setTitleValue}
        onSearchChange={ex.setTitleSearch}
        onBlur={ex.clearTitleSearch}
        disabled={false}
        error={ex.titleError}
        exerciseSuggestions={ex.exerciseSuggestions}
        onUpdate={ex.applySuggestion}
      />
      <LibraryHint hint={ex.libraryHint} onApply={ex.applyLibraryHint} />
      <Textarea
        label="Description"
        style={{ minHeight: 128 }}
        {...ex.register('description')}
      />
    </>
  );
};

export const ExerciseMedia = ({ exercise: ex }: ExerciseDetailsProps) => {
  if (!ex.media || Object.keys(ex.media).length === 0) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'baseline',
        }}
      >
        <Button
          variant="filled"
          color="neutral"
          onClick={() => ex.dispatch('AddMedia')}
        >
          Add +
        </Button>
      </div>
    );
  }

  return (
    <MediaPreview
      media={ex.media}
      videoType="short"
      removeVideo={() => ex.setValue('media', null)}
      disabled={false}
    />
  );
};
